import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { FALLBACK_ROUTE, isUserRole } from '../auth/route-access';

@Injectable({ providedIn: 'root' })
export class GuestGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    const hasValidSession = this.authService.isLoggedIn() && isUserRole(this.authService.getUserRole());
    return hasValidSession ? this.router.createUrlTree([FALLBACK_ROUTE]) : true;
  }
}
